import React from 'react';
import { motion } from 'framer-motion';
import { ExpandableTestimonial } from '../ui/ExpandableTestimonial';
const testimonials = [{
  quote: 'Brigitte is a brilliant leader in the data governance space. Her biggest strength is her ability to translate the murky waters of data governance into clear markers that clarify priorities and articulate a clear roadmap for success.',
  author: 'Peter Nichol',
  role: 'Strategic Business Relationship Manager',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8NSdQ4mLUnsvej8S3ShZmA/pasted-image.jpg'
}, {
  quote: 'Brigitte is an exceptional advisor and an asset to any organization seeking to enhance its data management and governance capabilities. Her contributions have been a key factor in our success, and I wholeheartedly recommend her services.',
  author: 'Alex Rothberg',
  role: 'Senior Integration Manager at Laticrete',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mB6fLqksgg5ijcouP469FT/pasted-image.jpg'
}];
export function TestimonialSection() {
  return <section className="bg-black py-24" data-id="element-143">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-144">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-medium text-white mb-4" data-id="element-146">
            What Our Clients Say
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-147">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.author} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} data-id="element-148">
              <ExpandableTestimonial {...testimonial} initials={testimonial.author.split(' ').map(name => name[0]).join('')} variant="home" data-id="element-149" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}